<template>
	<div>
		<div class="oa_auth flex" style="width: 100%;position: relative;flex-direction: row;align-items: center;">
			<template v-if="islist">

			</template>
			<template v-else>
				<div class="flex" style="flex-direction: column;width: 100%;margin: 10px 0;">
					<el-button size="mini" type="danger" style="width: 60px;margin-bottom: 10px;"
						@click="authModal">权限</el-button>
					<div>
						<el-tag style="margin: 2px;" v-for="(item,index) in authtext" :key="index" :type="item.type" effect="light">
							{{ item.value }}
						</el-tag>
					</div>
					<el-divider></el-divider>
				</div>
			</template>
		</div>
		<auth :extra="authextra" v-if="authShow" @submit="authSubmit" @back="authShow=false" />
	</div>


</template>
<style scoped>
	.inputbutton {
		border-radius: 0px;
		box-sizing: border-box;
		border-left: 0px;
		position: relative;
		padding: 7px 8px;
	}

	.oa_input>div {
		width: 100%
	}
</style>
<script>
	import selectBase from '@_system/components/base/select.js'
	import auth from '@_system/components/auth/index.vue'
	export default {
		mixins: [selectBase],
		props: {
			inputprops: {
				default: () => {
					return {
						type: 'text',
						rows: 2
					}
				}
			},
			table: {
				default: () => {
					return null
				}
			},
			importsearch: {
				default: () => {
					return false
				}
			},
			querySearchfield: {
				default: () => {
					return [{
						"value": "不为空"
					}, {
						"value": "为空"
					}]
				}
			},
		},
		data() {
			return {
				inputvalue: this.value,
				loading: false,
				modalShow: false,
				GridOptions: {},
				tableRef: Math.random(),
				importColumns: [],
				importData: [],
				tableImportcolumns: [],
				mode: 'list',
				ref: Math.random(),
				authextra: {},
				authtext: [],
				authShow: false
			}
		},
		created() {


		},
		mounted() {
			this.setauthExtra(this.value)
			// if (this.$slots.append) {
			// 	this.$refs.input.setAttribute('readonly', true)
			// }


			// 	let i = document.createElement('i')
			// 	this.$refs.input.parentNode.appendChild(<i class="el-icon-delete"></i>)
		},
		computed: {

		},
		watch: {
			value(v) {
				this.setauthExtra(v)
				this.setauthtext(v)
			},
			renderCell(e) {
				if (!e) {
					this.$nextTick(() => {
						this.$refs[this.ref].focus()
					})
				}
			}
		},
		methods: {
			setauthExtra(value) {
				if (value) {
					this.authextra.value = {
						auth: value
					}
				}
			},
			setauthtext(value) {
				console.log(value)
				let text = []
				if (value) {
					for (let i in value) {
						if (i == 'department') {
							value[i].forEach((_item) => {
								text.push({
									value:_item.departmentname + '【' + _item.typename + '】',
									tab:'department',
									type:'info'
								})
							})
						}
						if (i == 'group') {
							value[i].forEach((_item) => {
								text.push({
									value:_item.name,
									tab:'group',
									type:'warning'
								})
							})
						}
						if (i == 'joblevel') {
							value[i].forEach((_item) => {
								text.push({
									value:_item.name,
									tab:'group',
									type:'warning'
								})
							})
						}
						if (i == 'postjob') {
							value[i].forEach((_item) => {
								text.push({
									value:_item.name,
									tab:'group',
									type:'warning'
								})
							})
						}
						if (i == 'staff') {
							value[i].forEach((_item) => {
								text.push({
									value:_item.name + '【' + _item.departmentname + '】',
									tab:'group',
									type:'primary'
								})
							})
						}
					}
				}
				this.authtext = text
			},
			authModal() {
				this.authShow = true
			},
			authSubmit(e) {
				this.setauthExtra(e.data)
				this.setauthtext(e.data)
				this.change(e.data)
				//console.log(e)
				this.authShow = false

			}
		},
		components: {
			auth,

		}
	}
</script>